import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCount: 0,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoadingStart(state) {
      state.loadingCount += 1;
    },
    setLoadingEnd(state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
    },
    resetLoading(state) {
      state.loadingCount = 0;
    },
  },
});

export const { setLoadingStart, setLoadingEnd, resetLoading } = uiSlice.actions;

export const selectIsLoading = (state) => state.ui.loadingCount > 0;

export default uiSlice.reducer;
